import { default as BrightyCheckPng } from './brand/brighty/BrightyCheck.png';
import { default as BrightyCheckWebP } from './brand/brighty/BrightyCheck.webp';
import { default as BrightyCheckAvif } from './brand/brighty/BrightyCheck.avif';
import { ImageProps, image } from './image';

export function GraphicsCheckImage(props: ImageProps) {
  return __BRIGHTY__ ? image(props, BrightyCheckPng, BrightyCheckWebP, BrightyCheckAvif) : null;
}
